/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
/**
 *
 * @export
 * @interface BodyUpdateEpisodeApiV1EpisodesEpisodePut
 */
export interface BodyUpdateEpisodeApiV1EpisodesEpisodePut {
    /**
     * The new title of the episode.
     * @type {string}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    title?: string;
    /**
     * The new HTML content of the episode.
     * @type {string}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    html?: string;
    /**
     * The new episode number.
     * @type {number}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    episodeNumber?: number;
    /**
     * The new original date of the episode.
     * @type {Date}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    originalDate?: Date;
    /**
     * The new content of the episode.
     * @type {string}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    content?: string;
    /**
     * The new short content of the episode.
     * @type {string}
     * @memberof BodyUpdateEpisodeApiV1EpisodesEpisodePut
     */
    shortContent?: string;
}

/**
 * Check if a given object implements the BodyUpdateEpisodeApiV1EpisodesEpisodePut interface.
 */
export function instanceOfBodyUpdateEpisodeApiV1EpisodesEpisodePut(value: object): boolean {
    return true;
}

export function BodyUpdateEpisodeApiV1EpisodesEpisodePutFromJSON(
    json: any,
): BodyUpdateEpisodeApiV1EpisodesEpisodePut {
    return BodyUpdateEpisodeApiV1EpisodesEpisodePutFromJSONTyped(json, false);
}

export function BodyUpdateEpisodeApiV1EpisodesEpisodePutFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BodyUpdateEpisodeApiV1EpisodesEpisodePut {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'] == null ? undefined : json['title'],
        html: json['html'] == null ? undefined : json['html'],
        episodeNumber: json['episode_number'] == null ? undefined : json['episode_number'],
        originalDate: json['original_date'] == null ? undefined : new Date(json['original_date']),
        content: json['content'] == null ? undefined : json['content'],
        shortContent: json['short_content'] == null ? undefined : json['short_content'],
    };
}

export function BodyUpdateEpisodeApiV1EpisodesEpisodePutToJSON(
    value?: BodyUpdateEpisodeApiV1EpisodesEpisodePut | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        html: value['html'],
        episode_number: value['episodeNumber'],
        original_date:
            value['originalDate'] == null ? undefined : localDateString(value['originalDate']),
        content: value['content'],
        short_content: value['shortContent'],
    };
}
